/*
 * Error Manager Component: It is responsible for rendering error modal.
 */

import React, { Component, ReactNode } from 'react';
import { observer } from 'mobx-react';
import { CQAppStore } from '../../../store/cq-app-store';

/**
 * @export
 * @class InformationManager
 * @extends Component
 */
class InformationManager extends Component<{}, {}> {
    
    public renderInformationalModal(): ReactNode {
        const { informationalMessage } = CQAppStore.informational;
        return (
            <div className="slds-notify_container">
                <div className="slds-notify slds-notify_toast slds-theme_info" role="status">
                    <div className="slds-notify__content">
                        <h2 className="slds-text-heading_small ">
                            <div data-testid="info-message">{informationalMessage}</div>
                        </h2>
                    </div>
                    <div className="slds-notify__close">
                        <button className="slds-button slds-button_icon slds-button_icon-inverse" title="Close" onClick={() => this.hideToast()}>
                            <i className="cq-2x cq-icon-close"></i>
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    /**
     * Function used to check if toast message should be rendered or not
     * @memberof InformationManager
     */
    public render(): ReactNode {
        const { informationalFlag } = CQAppStore.informational;
        
        if (!informationalFlag) {
            return null
        }
        return (
            <div>
                {this.renderInformationalModal()}
            </div>
        )
    }

    /**
     * Function used to hide toast message
     * @memberof InformationManager
     */
    public hideToast = () => {
        CQAppStore.informational.hide();
    }
}

export const InformationManagerComponent = observer(InformationManager);
 